import { Navigate } from "react-router-dom";

export const PublicRoute = ({ children, isLogged }) => !isLogged ? children : <Navigate to='/home' />  